import type { BusinessSegmentConditions, SegmentConditionGroups } from '@reach/shared-types/conditions';

/**
 * Parse legacy segment conditions JSON. Caller should only invoke when `formatType === 'legacy'`.
 */
export function parseLegacyConditionsJson(
  contentsJson: string,
  isJsonValid: boolean,
): BusinessSegmentConditions | null {
  if (!contentsJson) return null;
  if (!isJsonValid) return null;
  try {
    return JSON.parse(contentsJson) as BusinessSegmentConditions;
  } catch {
    return null;
  }
}

/**
 * Parse new-format condition groups from editor JSON (array or `{ conditionGroups }` wrapper).
 */
export function parseConditionGroupsJson(contentsJson: string): SegmentConditionGroups | null {
  if (!contentsJson) return null;
  try {
    // Server-side validation is authoritative for condition-group payloads.
    const parsed = JSON.parse(contentsJson) as unknown;
    if (Array.isArray(parsed)) return parsed as SegmentConditionGroups;
    if (
      typeof parsed === 'object' &&
      parsed !== null &&
      'conditionGroups' in parsed &&
      Array.isArray((parsed as { conditionGroups: unknown }).conditionGroups)
    ) {
      return (parsed as { conditionGroups: SegmentConditionGroups }).conditionGroups;
    }
    return null;
  } catch {
    return null;
  }
}
